

























































































import WebServiceMarkup from "@/store/entities/flight/webServiceMarkup";


import { Component, Vue } from "vue-property-decorator";
import AddMarkupModal from "./modals/addMarkupModal.vue";

@Component({
  components: { AddMarkupModal },
})
export default class WebServiceMarkupPage extends Vue {
  isOpenModal: boolean = false;
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  webServiceMarkups: WebServiceMarkup[] = [];
  webServiceMarkup:WebServiceMarkup=new WebServiceMarkup();

  async getAuxiliaryMarkups() {
    await this.$store.dispatch({
      type: "webServiceMarkup/getAuxiliaryServiceMarkups"
    });
    
   this.webServiceMarkups = this.$store.state.webServiceMarkup.list;
  
  }

  async created() {
    await this.getAuxiliaryMarkups();
    
    (this.headers = [
      { text: "Servis", value: "service" },
      { text: "Kalkış", value: "departure" },
      { text: "Varış", value: "arrival" },
      { text: "Fiyat", value: "price" },
      { text: "Para Birimi", value: "currency" },
      { text: "İşlemler", value: "transactions" },
    ]),


    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Uçuş", disabled: true },
      { text: "WEB Servis Markup", disabled: true },
    ];
  }



  openModal() {
    
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
    this.$store.state.webServiceMarkup.editAuxiliaryMarkup=null;
    this.getAuxiliaryMarkups()
  }

  editAuxiliaryMarkup(item) {
    
    this.$store.state.webServiceMarkup.editAuxiliaryMarkup = item;
    this.isOpenModal = true;
  }

  async deleteAuxiliaryServiceMarkup(item) {
    await this.$store
      .dispatch({
        type: "webServiceMarkup/deleteAuxiliaryServiceMarkup",
        payload: item.id,
      })
      .then((x) => {
       this.getAuxiliaryMarkups()
      });
  }

    confirmDelete(item) {
    this.$swal({
      title: "Satır Silinecetir.",
      text: "İşlemi Devam Ettirmeye Emin misiniz?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Evet",
      cancelButtonText: "Hayır",
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteAuxiliaryServiceMarkup(item);
        Vue.$toast.success("Silme Başarılı");
      }
    });
  }


}
